<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="FM-Epigraph-non-verse-fmepi"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">Character is destiny.</span></p>
<p class="FM-Epigraph-Source-fmeps">—George Eliot, <i>Mill On The Floss</i></p>
<p class="FM-Epigraph-non-verse-fmepi">Let’s make us medicine of our great revenge,</p>
<p class="FM-Epigraph-non-verse-fmepi">to cure this deadly grief.</p>
<p class="FM-Epigraph-Source-fmeps">—William Shakespeare, <i>Macbeth</i></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7a70d0e0